// extracted by mini-css-extract-plugin
export default {"card":"ReportCardSkeleton_card__+Fiu-","cardTitle":"ReportCardSkeleton_cardTitle__fppZc"};